<template lang="html">
  <div class="footer_wrap">

    <div class="footer_container">
      <!--<div class="footer_component footer_location">
        <h1>Locatie</h1>
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d9773.738427013575!2d4.824889199999995!3d52.2354892!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x1ee94687e278c002!2sJ.+van+den+Wijngaart!5e0!3m2!1snl!2snl!4v1551537076729" frameborder="0" style="border:0" allowfullscreen></iframe>
      </div>-->
      <div class="footer_component footer_link">
        <h1>Links</h1>
        <router-link to="/">Home</router-link>
        <router-link to="/over">Over Ons</router-link>
        <router-link to="/portfolio">Portfolio</router-link>
        <router-link to="/contact">Contact</router-link>
      </div>
      <div class="footer_component footer_contact">
        <h1>Contact</h1>
        <h2>Zijdelveld 34-35, 1421 TJ Uithoorn</h2>
        <h2>vanden.wijngaart@hetnet.nl</h2>
        <h2>0297-540055 | 0297-564092</h2>
      </div>
      <div class="footer_component trustoo_block">
        <div class="trustoo-widget" data-id="16480" data-color="false" data-style="badge_h" data-border="false" data-size="med"></div>
      </div>
    </div>

    <div class="copyright_container">
      <p>© 2022 J. van den Wijngaart Alle rechten voorbehouden</p>
      <p>|</p>
      <p><a v-bind:href="'https://www.jvdwijngaart.nl:8080/AVW_J_vd_Wijngaart.pdf'" download>Algemene Voorwaarden</a></p>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css">

  .footer_keurmerken_wrap{
    width: 100%;
    background: #111;
  }

  .footer_keurmerken_container{
    padding: 0px 25px 25px 25px;
    display: flex;
    flex-direction: row;
  }

  .footer_keurmerken_logo{
    height: 80px;
    width: 70px;
    background-image: url('../../assets/logo/oh_logo2.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }

  .footer_keurmerken_text{
    margin-left: 20px;
    height: 100%;
  }

  .footer_keurmerken_text p{
    font-size: 14px;
    line-height: 18px;
    font-family: 'Segoe UI', sans-serif;
    font-weight: 400;
    color: #888;
    margin-bottom: 10px;
  }

  .keurmerken_icon{
    display: flex;
    flex-direction: row;
  }

  .keurmerken_icon h1{
    font-size: 25px;
    font-family: 'Segoe UI', sans-serif;
    font-weight: 800;
    color: #FFD700;
    line-height: 20px;
  }

  .keurmerken_icon i{
    font-size: 20px;
    color: #FFD700;
    margin-right: 5px;
  }

  .footer_wrap{
    display: flex;
    justify-content: center;
    flex-direction: column;
    background: #111;
    width: 100%;
  }

  .footer_container{
    display: flex;
    justify-content: space-around;
    max-width: 1000px;
    margin: auto;
    padding: 50px;
  }

  .footer_component{
    padding: 0 30px 0 30px;
  }
  
  .trustoo_block{
    background: #fff;
    padding: 1rem;
    border-radius: 0.25rem;
  }

  .footer_component h1{
    color: #fff;
    margin-bottom: 20px;
    font-size: 25px;
  }

  .footer_component h2{
    color: #888;
    font-weight: 300;
    font-size: 15px;
  }

  .footer_contact h2::before{
    font-size: 15px;
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    margin-right: 10px;
  }

  .footer_contact h2:nth-child(2)::before{
    content: "\f7a2";
  }

  .footer_contact h2:nth-child(4)::before{
    content: "\f095";
  }

  .footer_contact h2:nth-child(3)::before{
    content: "\f0e0";
  }

  .copyright_container{
    display: flex;
    justify-content: center;
    padding: 5px;
    background: #000;
  }

  .footer_link{
    display: flex;
    flex-direction: column;
  }

  .footer_link a{
    text-decoration: none;
    color: #888;
    font-weight: 300;
    font-size: 15px;
  }

  .footer_link .router-link-exact-active{
    font-weight: 800;
  }

  .footer_location iframe{
    border-radius: 10px;
    min-width: 500px;
    height: 250px;
  }

  .copyright_container p{
    margin: 0 5px 0 5px;
    font-size: 10px;
    font-weight: 800;
    color: #555;
  }

  @media only screen and (max-width : 650px) {
    .footer_wrap{
      display: block;
    }

    .footer_container{
      padding: 0;
      margin: 0;
      justify-content: flex-start;
    }

    .footer_link{
      display: none;
    }

    .footer_contact{
      padding: 25px;
    }

    .footer_component h1{
      line-height: 23px;
    }

    .footer_component h2{
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
      color: #888;
    }

    .footer_contact h2::before{
      font-size: 12px;
    }
  }
</style>
